export default __webpack_public_path__ + "static/program_3-cef38a3a01355cc392cbc38774763e34.png";